import * as React from 'react';
import { compose, withHandlers } from 'recompose';
import { reduxForm, change, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { get, parseInt } from 'lodash';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Divider from 'material-ui/Divider';

import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { RemoteAutoComplete, RemoteAutoCompleteField, Input, InputField, FormattedNumberInput } from '@components/form';
import * as T from '@modules/protocols/_protocolsTypes';
import { floatOnly, formatToDecimals, stringifyObject } from '@utils/utils';
import { required, isPositive } from '@utils/validators';

const enhance = compose<T.ProtocolsFormProps & T.Inner, T.Outter & T.ProtocolsFormProps>(
  connect((state: any) => ({ entity: formValueSelector('module-protocols-row')(state, 'card', 'amount') })),
  withHandlers({
    handleCardChange: ({ dispatch, entity }) => card => {
      const { amount = 0 } = entity;
      const { unitPrice = 0 } = card;

      dispatch(change('module-protocols-row', 'unitPrice', unitPrice));
      dispatch(change('module-protocols-row', 'totalPrice', amount * unitPrice));
    },
    handleAmountChange: ({ dispatch, entity }) => data => {
      const amount = parseInt(stringifyObject(data), 10) || 0;
      const { card } = entity;
      const { unitPrice = 0 } = card || {};
      dispatch(change('module-protocols-row', 'totalPrice', amount * unitPrice));
    }
  }),
  reduxForm({
    form: 'module-protocols-row'
  })
);

export const View: React.SFC<T.Outter & T.ProtocolsFormProps & T.Inner> = ({
  handleSubmit,
  closeItem,
  handleCardChange,
  handleAmountChange,
  type,
  itemsUrl,
  itemsParams
}) => (
  <div>
    <form className="layout" onSubmit={handleSubmit}>
      <Grid fluid={true}>
        <Row>
          <Col className="grid-system-margin" />
        </Row>

        <Row>
          <Col md={12}>
            <Row>
              <Col md={4}>
                <h4>Skladová karta *</h4>
              </Col>
              <Col md={8}>
                <RemoteAutoCompleteField
                  name="card"
                  id="card"
                  component={RemoteAutoComplete}
                  url={itemsUrl}
                  params={itemsParams}
                  labelFunction={o => get(o, 'label')}
                  onChange={handleCardChange}
                  validate={[required]}
                  arrowstyle={{
                    color: '#e1e0e1',
                    position: 'absolute',
                    right: 0,
                    top: 16
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <h4>Množství *</h4>
              </Col>
              <Col md={8}>
                <InputField
                  component={Input}
                  name="amount"
                  type="number"
                  id="amount"
                  onChange={handleAmountChange}
                  validate={[required, isPositive]}
                />
              </Col>
            </Row>
            {type === 'issue' && (
              <Row>
                <Col md={4}>
                  <h4>Výstrojní lhůta *</h4>
                </Col>
                <Col md={8}>
                  <InputField component={Input} name="daysLimit" id="daysLimit" validate={[required]} />
                </Col>
              </Row>
            )}
            <Row>
              <Col md={4}>
                <h4>Jednotková cena</h4>
              </Col>
              <Col md={8}>
                <InputField
                  component={FormattedNumberInput}
                  name="unitPrice"
                  id="unitPrice"
                  normalize={floatOnly}
                  format={v => formatToDecimals(v)}
                  disabled={true}
                />
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <h4>Celková cena</h4>
              </Col>
              <Col md={8}>
                <InputField
                  component={FormattedNumberInput}
                  name="totalPrice"
                  id="totalPrice"
                  normalize={floatOnly}
                  format={v => formatToDecimals(v)}
                  disabled={true}
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col className="grid-system-margin" />
        </Row>
      </Grid>

      <Divider />

      <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
      <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
    </form>
  </div>
);

export const ProtocolsRowForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/protocols/ProtocolsRowForm.tsx